let sectionVideoSwitchGrid = document.querySelectorAll('.block_content_image_switch_grid');

if (sectionVideoSwitchGrid) {
    sectionVideoSwitchGrid.forEach(function (el) {
        const youtubeHolder = el.querySelector('.youtube-holder');
        const embedHolder = el.querySelector('.youtube-holder .embed');
        //mixed
        let playButton = el.querySelector('.block_content_image_switch_grid .button-play');
        let playButtons = el.querySelectorAll('.block_content_image_switch_grid .button-play');

        if (youtubeHolder) {
            let closeButton = youtubeHolder.querySelector('.close-video');

            playButtons.forEach(function (elm) {
                elm.addEventListener('click', function () {
                    elm.style.display = 'none';

                    let iframe = document.createElement('iframe');
                    iframe.setAttribute('frameborder', '0');
                    iframe.setAttribute('allowfullscreen', '');
                    iframe.setAttribute('src', this.dataset.embed + '?rel=0&showinfo=0&autoplay=1&enablejsapi=1');

                    closeButton.style.display = 'block';
                    youtubeHolder.style.display = 'block';
                    embedHolder.innerHTML = '';
                    embedHolder.appendChild(iframe);
                });

            });

            closeButton.addEventListener('click', function () {
                youtubeHolder.style.display = 'none';
                playButton.style.display = 'flex';
                embedHolder.innerHTML = '';
            });
        }
    });
}
